import React, { useState, useEffect } from 'react';
import './MaintenanceBubble.css';
import axios from 'axios';

const MaintenanceBubble = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isDismissed, setIsDismissed] = useState(false);

    const checkStatus = async () => {
        try {
            const res = await axios.get('/api/maintenance/status');
            setIsVisible(res.data.maintenance_mode);
        } catch (error) {
            console.error('Error checking maintenance status', error);
        }
    };

    useEffect(() => {
        checkStatus();
        const interval = setInterval(checkStatus, 60000); // Check every minute
        return () => clearInterval(interval);
    }, []);

    if (!isVisible || isDismissed) return null;

    return (
        <div className="maintenance-bubble">
            <div className="maintenance-content">
                <span className="maintenance-icon">⚠️</span>
                <span className="maintenance-text">
                    Webs Currently under Maintenance, you may experiece disconnection temporary
                </span>
                <button className="maintenance-close" onClick={() => setIsDismissed(true)}>
                    &times;
                </button>
            </div>
        </div>
    );
};

export default MaintenanceBubble;
